import React from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { usePrivacyContext } from 'contexts/PrivacyContext';
import { features } from 'configs';
import './SharingModal.css';

export function SharingModal({ state }) {
  const history = useHistory();
  const { isSharing } = usePrivacyContext();

  async function handleModalSubmit() {
    history.push('/privacidade');
  }

  return (

    <Dialog
      className="sharingModal"
      open={!isSharing && features.policy}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Mude sua política de compartilhamento</DialogTitle>
      <DialogContent>
        <div className="sharingModal-text">
          <p>
            Você optou em não compartilhar suas informações de saúde.
          </p>
          <p>
            Para que você possa voltar a controlar suas opções de compartilhamento, altere sua opção de privacidade no menu “Privacidade”.
          </p>
        </div>
      </DialogContent>
      <DialogActions>
        <button
          className="sharingModal-goBackButton" type="button"
          onClick={() => {
            history.goBack();
          }}
        >
          Cancelar
        </button>
        <button className="sharingModal-privacyButton" type="button" onClick={handleModalSubmit}>
          Confirmar
        </button>
      </DialogActions>
    </Dialog>

  );
}
